import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('mapAddressSearch');

    return {
        NO_RESULTS: t('noResults'),
        PLACEHOLDER: t('placeholder')
    };
};

export default useTranslation;
